import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class PlantOperationCapacityDto{
    @ApiProperty()
    @IsNotEmpty({message:"plant operation capacity id should not be empty"})
    @IsAlphanumeric()
   plantOperationId:number;

   
   
   @ApiProperty()
    @IsNotEmpty({message:"plant id should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    plantId:number ;

    // @ApiProperty()
    // @IsNotEmpty({message:"plant id should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // plantName:string;

    // @ApiProperty()
    // @IsNotEmpty({message:"plant id should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // operationName:string;


    @ApiProperty()
    @IsNotEmpty({message:"operation id should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    operationId:number ;

   @ApiProperty()
    @IsNotEmpty({message:"count1 should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    mincount:number;

   @ApiProperty()
    @IsNotEmpty({message:"count2 should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    maxcount:number;

    @ApiProperty()
    isActive: boolean;

    createdAt : Date;

   @ApiProperty()
   @IsOptional()
   @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
   createdUser :string ;

   updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;
  

  @ApiProperty()
  versionFlag : number;
}